import type { QuestionnaireRevisionContext } from '@gcv/shared';

import { getLatestRevision } from './get-latest-revision';

// `due_date` is set on each revision context entry by the BE but is not yet on the shared type.
type RevisionContextWithDueDate = QuestionnaireRevisionContext & { due_date?: string };

export const getEffectiveDueDate = (
  history: QuestionnaireRevisionContext[] | undefined,
  fallback: string
): string => {
  const latest = getLatestRevision(history) as RevisionContextWithDueDate | undefined;
  return latest?.due_date ?? fallback;
};
